<template>
  <div class="nav-row" :class="{ 'is-pinned': pinned, 'is-rail': rail }">
    <v-tooltip right :disabled="!rail" :open-delay="120" content-class="app-nav-tip">
      <template #activator="{ on, attrs }">
        <router-link
          v-slot="{ href, navigate, isActive }"
          :to="item.to"
          custom
        >
          <a
            v-bind="attrs"
            :href="href"
            class="nav-item"
            :class="{ 'is-active': isActive }"
            :aria-current="isActive ? 'page' : null"
            :aria-label="rail ? label : null"
            data-nav-focus
            @click="onClick($event, navigate)"
            v-on="on"
          >
            <v-icon class="nav-ic" size="22">{{ icon }}</v-icon>
            <span v-if="!rail" class="nav-lb">
              <template v-if="parts"
                ><span>{{ parts[0] }}</span
                ><mark>{{ parts[1] }}</mark
                ><span>{{ parts[2] }}</span></template
              >
              <template v-else>{{ label }}</template>
            </span>
          </a>
        </router-link>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
    <button
      v-if="!rail"
      type="button"
      class="nav-pin"
      :aria-pressed="String(pinned)"
      :aria-label="(pinned ? $t('nav_unpin') : $t('nav_pin')) + ': ' + label"
      @click.stop="$emit('pin', item)"
    >
      <v-icon size="16">{{ pinned ? "mdi-star" : "mdi-star-outline" }}</v-icon>
    </button>
  </div>
</template>

<script>
import { normText } from "@/utils/searchText";
import { navIcon } from "@/utils/menuGroups";

export default {
  name: "NavItem",
  props: {
    item: { type: Object, required: true },
    label: { type: String, required: true },
    rail: { type: Boolean, default: false },
    pinned: { type: Boolean, default: false },
    query: { type: String, default: "" },
  },
  computed: {
    icon() {
      return navIcon(this.item);
    },
    // Podvučen pogodak pretrage; samo kad normalizovani tekst ima istu dužinu kao naziv (inače bi pomak bio pogrešan).
    parts() {
      const q = normText(this.query).trim();
      if (!q) return null;
      const n = normText(this.label);
      if (n.length !== this.label.length) return null;
      const at = n.indexOf(q);
      if (at < 0) return null;
      return [this.label.slice(0, at), this.label.slice(at, at + q.length), this.label.slice(at + q.length)];
    },
  },
  methods: {
    onClick(event, navigate) {
      navigate(event);
      this.$emit("go", this.item);
    },
  },
};
</script>
